module.exports = __webpack_public_path__ + "img/profgrams-active.e83c90dc.svg";